export enum QueueTaskState {
  Running = 'Running',
  Completed = 'Completed',
  Failed = 'Failed'
}
